var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcToolModo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1351",
    "data-name": "Grupo 1351",
    transform: "translate(-0.367 -0.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1121",
    "data-name": "Grupo 1121",
    transform: "translate(0.407 0.407)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1120",
    "data-name": "Grupo 1120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1119",
    "data-name": "Grupo 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1118",
    "data-name": "Grupo 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 17,
    height: 17,
    transform: "translate(-0.04 -0.04)",
    fill: "#684e07"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1352",
    "data-name": "Grupo 1352",
    transform: "translate(-1.69 -2.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_577",
    "data-name": "Trazado 577",
    d: "M13.242,16.716A4.917,4.917,0,0,1,8.2,11.655a5.043,5.043,0,0,1,10.085,0A4.912,4.912,0,0,1,13.242,16.716Zm-.458-.887V7.555A4.061,4.061,0,0,0,9.117,12,4.024,4.024,0,0,0,12.783,15.829Z",
    transform: "translate(-0.633 -0.637)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_578",
    "data-name": "Trazado 578",
    d: "M9.882,21.957a.473.473,0,0,1-.448-.612c.338-.786.693-1.567,1.052-2.344a.44.44,0,0,1,.793.376c-.338.768-.687,1.531-1.033,2.3a.118.118,0,0,1-.026.047C10.108,21.8,9.994,21.878,9.882,21.957Z",
    transform: "translate(-0.816 -2.489)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_579",
    "data-name": "Trazado 579",
    d: "M7.463,9.243a.437.437,0,0,1-.652.377c-.523-.24-1.041-.487-1.562-.73-.208-.1-.418-.192-.624-.294a.441.441,0,1,1,.369-.8c.735.341,1.468.686,2.2,1.031A.426.426,0,0,1,7.463,9.243Z",
    transform: "translate(-0.042 -0.806)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_580",
    "data-name": "Trazado 580",
    d: "M10.69,2.468a.411.411,0,0,1,.369.28c.28.77.558,1.542.828,2.317a.431.431,0,0,1-.269.558.436.436,0,0,1-.559-.274q-.418-1.148-.819-2.3A.442.442,0,0,1,10.69,2.468Z",
    transform: "translate(-0.94)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_581",
    "data-name": "Trazado 581",
    d: "M4.525,16.366a.447.447,0,0,1-.457-.353.426.426,0,0,1,.286-.5c.462-.177.927-.347,1.391-.521.277-.1.553-.211.831-.313a.452.452,0,0,1,.62.232.441.441,0,0,1-.305.586q-1.111.421-2.222.834A1.246,1.246,0,0,1,4.525,16.366Z",
    transform: "translate(0 -1.858)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_582",
    "data-name": "Trazado 582",
    d: "M14.518,20.386c0,.169,0,.34,0,.509a.445.445,0,0,1-.436.463.43.43,0,0,1-.447-.447c-.012-.345-.012-.691,0-1.036a.427.427,0,0,1,.449-.444.443.443,0,0,1,.434.464C14.522,20.059,14.518,20.222,14.518,20.386Z",
    transform: "translate(-1.461 -2.59)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_583",
    "data-name": "Trazado 583",
    d: "M14.518,4.491c0,.164,0,.327,0,.491a.452.452,0,0,1-.435.469A.444.444,0,0,1,13.634,5c-.011-.345-.012-.691,0-1.036a.442.442,0,0,1,.449-.451.451.451,0,0,1,.434.469C14.522,4.151,14.518,4.321,14.518,4.491Z",
    transform: "translate(-1.461 -0.159)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_584",
    "data-name": "Trazado 584",
    d: "M6.038,12.088c.169,0,.34,0,.509,0a.434.434,0,0,1,.444.431.419.419,0,0,1-.43.441q-.535.011-1.072,0a.423.423,0,0,1-.427-.444.436.436,0,0,1,.43-.428C5.675,12.083,5.857,12.088,6.038,12.088Z",
    transform: "translate(-0.154 -1.469)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_585",
    "data-name": "Trazado 585",
    d: "M8.745,17.251a.474.474,0,0,1,.4.267.376.376,0,0,1-.041.443c-.268.289-.544.569-.832.837a.42.42,0,0,1-.577-.036.414.414,0,0,1-.032-.576c.262-.285.541-.555.822-.821A.882.882,0,0,1,8.745,17.251Z",
    transform: "translate(-0.535 -2.258)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_586",
    "data-name": "Trazado 586",
    d: "M8.729,7.664a1.293,1.293,0,0,1-.291-.156c-.252-.235-.494-.48-.733-.729a.438.438,0,1,1,.62-.619c.248.239.491.483.73.731a.41.41,0,0,1,.091.484A.492.492,0,0,1,8.729,7.664Z",
    transform: "translate(-0.536 -0.543)",
    fill: "#684e07"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToolModo);
export default __webpack_public_path__ + "static/media/ic_tool_modo.78fe73380aafc91a320a2002a6503b28.svg";
export { ForwardRef as ReactComponent };